import { posthogId } from "../../constants.ts";

// posthog-js accesses window.navigator at import time, crashing during SSR prerendering.
// Dynamic import is required here despite AGENTS.md preference for static imports.
const phPromise = typeof window !== "undefined"
  ? import("posthog-js").then(({ default: posthog }) =>
    posthog.init(posthogId, { api_host: "https://app.posthog.com" })
  )
  : Promise.resolve(null);

export const logError = (error: Error | { message: string }) => {
  console.error(error);
  const { message, stack } = error instanceof Error
    ? error
    : new Error(error.message);
  phPromise.then((ph) => ph?.capture("Client side error", { message, stack }));
};
